import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-login-index" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "title" }, " 敏捷平台 ", -1)),
    _createVNode(_component_el_button, {
      type: "primary",
      onClick: _ctx.goScanCode
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(" 扫码登录 ")
      ])),
      _: 1
    }, 8, ["onClick"])
  ]))
}